import * as React from "react";
import { Router, Route, Switch } from "react-router-dom";
import { Provider } from "mobx-react";
import * as store from "../store/Store";
import history from "./history";

// =====================================
// COMPONENTS
import Layout from "./Layout/Layout";
import Customers from "./Customer/Customers";
import Orders from "./Orders/Orders";
import OrderDetails from "./Orders/OrderDetails";
import Articles from "./Articles/Articles";
import NewOrder from "./Orders/NewOrder";
import Welcome from "./Layout/Welcome";
import Login from "./Login/Login";
import Register from "./Login/Register";
import Pricelist from "./Pricelist/Pricelist";
import AcceptedOrders from "./Orders/AcceptedOrders";
import NewCustomer from "./Customer/NewCustomer";
import Info from "./Info/Info";
import EditOrder from "./Orders/EditOrder";

export class App extends React.Component<any, any> {
    render() {
        return (
            <Provider store={store.store}>
                <Router history={history}>
                    <Switch>
                        <Route exact path="/" component={Welcome} />
                        <Route exact path="/login" component={Login} />
                        <Route exact path="/register" component={Register} />
                        <Layout>
                            <Route exact path="/customers" component={Customers} />
                            <Route exact path="/newcustomer" component={NewCustomer} />
                            <Route exact path="/pricelist" component={Pricelist} />
                            <Route exact path="/orders/:customerId" component={Orders} />
                            <Route exact path="/acceptedorders/:customerId" component={AcceptedOrders} />
                            <Route exact path="/info/:customerId" component={Info} />
                            <Route exact path="/orderdetails/:customerId/:orderId/:isInboundOrder" component={OrderDetails} />
                            <Route exact path="/neworder/:customerId" component={NewOrder} />
                            <Route exact path="/articles/:customerId/:isEditOrder/:orderId?" component={Articles} />
                            <Route exact path="/editorder/:customerId/:orderId" component={EditOrder} />
                        </Layout>
                    </Switch>
                </Router>
            </Provider>
        );
    }
}